/* 全局搜索，带图片搜索 */

<template>
  <div class="zSearch">
    <div class="search-banner" :class="focusStyle ? 'border-active' : ''">
      <Row type="flex" justify="space-between" align="top">
        <Col :span="'2'" @click.native="showInputHandle">
          <upload
            v-if="filePolicy"
            :ossKey="filePolicy"
            :type="fileType"
            @progress="handleProgress"
            @success="uploadImageSuccess"
            @uploadError="uploadImageErr"
            @formatError="formatError"
            @handleMaxSize="handleMaxSize"
            class="upload-block"
          >
            <i :class="iconFont + ' ' + 'icon-camera1'"></i>
          </upload>
        </Col>
        <Col :span="'18'">
          <Input
            ref="inputEle"
            v-model="keywords"
            @on-focus="focusHandle"
            @on-enter="inputSearch"
            :maxlength="50"
            @on-blur="blurHandle"
            v-point-input="{
              category: '搜索-头部',
              action: '回车事件',
              label: keywords,
              value: '',
            }"
            :placeholder="uploadImg ? '' : '请输入关键词进行搜索'"
          ></Input>
        </Col>
        <Col span="4">
          <button class="input-search-btn" @click="inputSearch">
            <i class="iconfont icon-sousuo1"></i>
          </button>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import upload from '../upload/upload.vue'
import Cookie from 'js-cookie'
export default {
  name: 'ZSearch',
  data() {
    return {
      keywords: '',
      uploadImg: false,
      Message: '',
      files: '',
      count: 0,
      focusStyle: false,
    }
  },
  props: {
    VUE_APP_COOKIE_DOMAIN: {
      type: String,
      default: '',
    },
    iconFont: {
      type: String,
      default: 'iconfont',
    },
    filePolicy: {
      type: [String, Object],
      default: '',
    },
    fileType: {
      type: [String, Number],
      default: 3,
    },
    ossPrefix: {
      type: String,
      default: '',
    },
    // 三个项目的baseUrl
    baseUrl: {
      type: Object,
      default: function() {
        return {}
      },
    },
    thisUrl: {
      type: String,
      default: '',
    },
  },
  components: {
    upload,
  },
  methods: {
    setCookiesValue(name, value) {
      Cookie.set(name, value, {
        expires: 30,
        domain: this.VUE_APP_COOKIE_DOMAIN,
      })
    },
    /* 全局加载提示upload */
    handleProgress() {
      this.$emit('hideInput')
      this.count += 1
      if (this.count === 1) {
        this.$Message.loading({
          content: '图片上传中...',
          duration: 0,
        })
      }
    },
    uploadImageSuccess(file) {
      if (!file || !file.data[0]) return false
      this.files = file.data[0].key
      this.setCookiesValue('imgSearchLocal', this.files)
      this.focusStyle = false
      this.$emit('blurView')
      this.$Message.destroy()
      this.toUrl()
      this.count = 0
    },
    uploadImageErr() {
      this.count = 0
    },
    formatError() {
      this.count = 0
    },
    handleMaxSize() {
      this.count = 0
    },
    /* 跳转判断 */
    toUrl() {
      switch (this.thisUrl) {
        case 'nuxt':
          this.$router.push({ path: '/list/inspiration?imgsearch=1' })
          break
        default:
          location.href = `${this.baseUrl.baseNuxt}/list/inspiration?imgsearch=1`
      }
    },
    /* 点击显示 */
    showInputHandle() {
      this.$emit('showInput')
    },
    /* 获得焦点 */
    focusHandle() {
      this.focusStyle = true
      this.$emit('focusView')
    },
    /* 失去焦点 */
    blurHandle() {
      this.focusStyle = false
      this.$emit('blurView')
    },

    /* 输入框，按钮搜索 */
    inputSearch() {
      if (!this.keywords) return false
      this.focusStyle = false
      this.$emit('showInput')
      this.$emit('inputSearch', this.keywords)
    },
  },
  created() {
    this.$nextTick(() => {
      this.$refs.inputEle.focus()
    })
  },
}
</script>

<style lang="scss" scoped>
.zSearch {
  width: 355px;
  .search-banner {
    position: relative;
    background: #fff;
    height: 35px;
    padding: 3px;
    border: 1px solid #bdbdbd;
    border-radius: 2px;
    margin-top: 6px;
    overflow: hidden;
    /deep/ .upload-block {
      height: 29px;
      line-height: 29px;
    }
    /deep/ .ivu-upload-drag {
      background: #fff;
    }
    /deep/ .input-search-btn {
      background: #eb5757;
      border: none;
      border-radius: 2px;
      height: 28px;
      line-height: 28px;
      width: 100%;
      padding: 0px !important;
      display: block;
      margin-top: -1px;
      cursor: pointer;
      &:focus {
        box-shadow: none;
        outline: none;
      }
      i {
        color: #fff !important;
        font-size: 22px;
        font-weight: bold;
      }
    }
    .ivu-row-flex {
      height: 100%;
      .ivu-col {
        height: 100%;
      }
    }
    .zUpload .ivu-upload-drag {
      background: #fff;
    }
    .slot-con {
      height: 30px;
      line-height: 30px;
      width: 32px;
      float: left;
      margin-top: -2px;
      span {
        font-size: 18px;
      }
    }
    /deep/ .ivu-input-wrapper {
      height: 30px;
      vertical-align: top;
      margin-top: -1px;
      .ivu-input {
        height: 30px;
        border: none;
      }
    }
    .imgIview {
      height: 22px;
      max-width: 28px;
      display: inline-block;
      font-size: 0px;
      margin-top: -1px;
      vertical-align: top;
      position: relative;
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
      i {
        position: absolute;
        top: 6px;
        display: inline-block;
        height: 20px;
        line-height: 20px;
        left: 32px;
        z-index: 10;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
  .border-active {
    border: 1px solid #707070;
  }
}
</style>
